module.exports = __webpack_public_path__ + "img/17_36.3b954f32.png";